import React, { useEffect, useRef, useState } from 'react';

import Button from 'Components/organisms/Button';
import Modal from 'react-modal';
import ToastPopup from 'Components/organisms/ToastPopup';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

Modal.setAppElement('#root');
function PopModal(props) {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [currentScroll, setCurrentScroll] = useState(0);
  useEffect(() => {
    if (props?.open) {
      setIsModalOpened(true); //페이지 로드시 애니메이션 동작 방지
    }
  });
  window.onscroll = function () {
    if (props?.open) {
      window.scrollTo(0, currentScroll);
    }
  };
  useEffect(() => {
    setCurrentScroll(document.documentElement.scrollTop);
  }, [props?.open]);

  return (
    isModalOpened && (
      <div
        className={cx('pop-modal-full-container', props?.open && 'pop-modal-full-container-show')}
      >
        {props?.onClose && (
          <div className={cx('close-screen')} onClick={() => props?.open && props?.onClose()} />
        )}
        <div className={cx('pop-modal-container', props?.open && 'pop-modal-container-show')}>
          {props?.toastOpen && (
            <ToastPopup
              title={props?.toastTitle}
              description={props?.toastDescription}
              close={props?.toastClose}
              open={props?.toastOpen}
              location={'top'}
            />
          )}
          <div className={cx('pop-modal-container-wrapper')}>
            <div className={cx('pop-modal-info-container')}>
              <div className={cx('pop-modal-title')}>{props?.title}</div>
              {props?.description && (
                <div className={cx('pop-modal-description')}>{props?.description}</div>
              )}
              {props?.renderDescription && (
                <div className={cx('pop-modal-description')}>{props?.renderDescription()}</div>
              )}
              {props?.children && <div className={cx('pop-modal-content')}>{props?.children}</div>}
              {props?.buttonText && (
                <div className={cx('pop-modal-button')}>
                  <Button
                    type={'large'}
                    fillType={'coral'}
                    fullWidth
                    onClick={props?.buttonOnClick}
                  >
                    {props?.buttonText}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default PopModal;
